import {
  Paper,
  Popper,
  Stack,
  Typography,
  Box,
  Button
} from '@material-ui/core';

const OptionsPopup = ({ opened, anchorEl, list, onSelect, renderOption, placement }) => {
  return (
    <Popper placement={placement ?? 'bottom-end'} open={opened} anchorEl={anchorEl} style={{ zIndex: 2 }}>
      <Paper style={{ backgroundColor: '#eee' }}>
        <Stack spacing={1} padding={2}>
          {list?.map(item => (
            <Button type='button' key={item.id}
                    sx={{ width: 400, display: 'flex', backgroundColor: '#fff', cursor: 'pointer', justifyContent: 'flex-start' }}
                    onClick={() => onSelect(item)}>
              {renderOption(item)}
            </Button>
          ))}
        </Stack>
      </Paper>
    </Popper>
  );
};

export default OptionsPopup;
